import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import StudentSidebar from '../StudentSidebar/StudentSidebar'
import { useDispatch, useSelector } from 'react-redux';
import { getTutorReviewData } from '../../../Redux/action/TutorAction';
import { useFormik } from 'formik';
import axios from 'axios';
import toast from 'react-hot-toast';
import * as Yup from "yup";
import { Rating } from 'react-simple-star-rating';
import { jwtDecode } from 'jwt-decode';
const host = process.env.REACT_APP_API_SERVER
const StudentReview = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const tutor_id = location?.state?.tutor_id
    const student_id = location?.state?.student_id
    const session_id = location?.state?.session_id
    const booked_id = location?.state?.booked_id



    const handleRating = (rate) => {
        formik.setFieldValue('rating', rate)
    }
    const formik = useFormik({
        initialValues: {
            rating: 0,
            review: ''
        },
        validationSchema: Yup.object().shape({
            rating: Yup.string().required("Rating is required"),
            review: Yup.string().required("Review is required"),
        }),
        onSubmit: async (values, { setSubmitting, resetForm }) => {

            try {

                setSubmitting(true);


                const value = {

                    review: values.review,
                    rating: values.rating,
                    tutor_id: tutor_id,
                    student_id: student_id,
                    session_id: session_id,
                    booked_id: booked_id
                }


                const authToken = localStorage.getItem('student-token')

                let config = {
                    headers: {
                        "x-auth-token": authToken,
                    },
                };
                await axios.post(`${host}/api/student/give-review/tutor`, value, config)
                    .then(function (response) {
                        if (response.status == 200) {
                            setSubmitting(false)

                            toast.success("Ratings Submitted Succesfully");

                            resetForm();
                            navigate('/student/dashboard')

                        } else {

                            setSubmitting(false)

                            toast.error(response.data.msg);



                        }
                    })
                    .catch(function (error) {

                        document.body.style.overflow = 'auto';
                        setSubmitting(false)
                        toast.error(error.response.data.message);


                    })

            }
            catch (error) {


                setSubmitting(false)
                toast.error(error.response.data.message);


            }

        }
    })

    return (
        <div>

            <section className="after-header">
                {/* Breadcrum Start */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item  ps-5" aria-current="page">
                            <Link to="javascript:history.back()">
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </Link>
                            &nbsp;&nbsp;Feedback
                        </li>
                    </ol>
                </nav>
                {/* Breadcrum End */}
                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <StudentSidebar />
                        </div>
                        <div className="col-lg-9">
                            <form onSubmit={formik.handleSubmit}>
                                <main className="px-3 py-4">
                                    <h2>Give feedback</h2>
                                    <p className="fw-bold mb-0 text-start">Rate your Tutor</p>
                                    <div className="rating text-start">
                                        <Rating
                                            onClick={handleRating}


                                        />
                                        <div className="help-block with-errors mb-3">
                                            {formik.touched.rating && formik.errors.rating ? (
                                                <div className='text-danger'>{formik.errors.rating}</div>
                                            ) : null}
                                        </div>
                                    </div>
                                    <p className="mt-4 fw-bold text-start">Write your feedback about Tutor</p>
                                    <textarea
                                        className="input-card-form border"
                                        style={{ height: "10rem" }}
                                        name="review"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.review}
                                    />
                                    <div className="help-block with-errors mb-3">
                                        {formik.touched.review && formik.errors.review ? (
                                            <div className='text-danger'>{formik.errors.review}</div>
                                        ) : null}
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-3 col-md-3 col-sm-4 my-2">
                                            <button type='submit' className="btn btn-primary w-100">Submit</button>
                                        </div>
                                        <div className="col-lg-3 col-md-3 col-sm-4 my-2">
                                            <Link to='/student/dashboard'>
                                                <button className="btn btn-outline-primary w-100">Later</button>
                                            </Link>
                                        </div>
                                    </div>
                                </main>
                            </form>
                        </div>
                    </div>
                </div>
            </section>

        </div>
    )
}

export default StudentReview